import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard, Lock, Bell, Shield } from 'lucide-react';
import { AppLayout } from '../../../components/layouts';
import PageHeader from '../../../components/dashboard/PageHeader';

type SettingItem = {
    icon: React.ElementType;
    title: string;
    description: string;
    to?: string;
    href?: string;
};

const items: SettingItem[] = [
    {
        icon: CreditCard,
        title: 'Payment History',
        description: 'View receipts and past program payments.',
        to: '/parent/payment-history',
    },
    {
        icon: Lock,
        title: 'Password & security',
        description: 'Change your password from the Profile page.',
        to: '/parent/profile',
    },
    {
        icon: Bell,
        title: 'Notifications',
        description: 'Class reminders and report alerts (coming soon).',
    },
    {
        icon: Shield,
        title: 'Privacy',
        description: 'How we protect your family data.',
        href: 'https://rydlearning.com/terms/#privacy-policy',
    },
];

export default function SettingsPage() {
    const navigate = useNavigate();

    return (
        <AppLayout>
            <PageHeader
                title="Settings"
                subtitle="Manage account preferences, payments, and security options."
            />
            <div className="grid gap-4 sm:grid-cols-2">
                {items.map((item) => {
                    const Icon = item.icon;
                    return (
                        <button
                            key={item.title}
                            type="button"
                            disabled={!item.to && !item.href}
                            onClick={() => {
                                if (item.to) navigate(item.to);
                                else if (item.href) window.open(item.href, '_blank', 'noopener,noreferrer');
                            }}
                            className="rounded-[20px] border border-[#efe6f1] bg-white p-5 text-left shadow-[0_8px_30px_rgba(136,22,122,0.04)] transition hover:-translate-y-0.5 hover:shadow-[0_14px_40px_rgba(136,22,122,0.1)] disabled:cursor-default disabled:opacity-70"
                        >
                            <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-2xl bg-ryd-primaryLess1 text-ryd-primary">
                                <Icon size={20} />
                            </div>
                            <p className="font-[AvertaStd-Semibold] text-[16px] text-ryd-headerTextPrimary">{item.title}</p>
                            <p className="mt-1 text-[13px] text-[#8b9aab]">{item.description}</p>
                        </button>
                    );
                })}
            </div>
        </AppLayout>
    );
}
